var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ib-blinking-animation',{attrs:{"text":`${_vm.$t('generatingTemplate')}`,"handwriting":"","font-size":"18px","variant":"violet"}})
}
var staticRenderFns = []

export { render, staticRenderFns }